import { parseISO } from 'date-fns';

export function parseDate(date: string | Date) {
  return parseISO(String(date));
}
